import React from 'react';
import { Link } from 'react-router-dom';
import PageShell from '../Components/ui/PageShell';
import { getUserType } from '../utils/authStorage';

function ReportsHub() {
  const userType = getUserType();

  const reports = [
    {
      title: 'Today Work Monitor',
      description: 'Profiles that need follow-up today — interviews, offers, pending actions',
      to: '/work/today',
      roles: ['TeamLead'],
    },
    {
      title: 'Interview Schedule',
      description: 'Upcoming interviews with date and time scheduling',
      to: '/work/interviews',
      roles: ['Admin', 'TeamLead', 'User'],
    },
    {
      title: 'Status Tracking',
      description: 'Pipeline stages with candidate drill-down for manager performance',
      to: '/reports/tracking',
      roles: ['Admin', 'TeamLead'],
    },
    {
      title: 'Recruitment Analytics',
      description: 'Pipeline funnel, profiles sourced, and interview metrics',
      to: '/reports/analytics',
      roles: ['Admin'],
    },
    {
      title: 'Employee Work Summary',
      description: 'Recruiter and team lead assignments, sourcing, and status outcomes',
      to: '/admin/employee-work-summary',
      roles: ['Admin'],
    },
    {
      title: 'Recruiter / TL Requirement Details',
      description: 'Requirement assignments and clients by recruiter or team lead',
      to: '/admin/recruiter-tl-requirement-details',
      roles: ['Admin'],
    },
  ].filter((r) => r.roles.includes(userType));

  return (
    <PageShell
      title="Reports"
      subtitle="Each report opens a dedicated page — pick the view that matches what you need to track."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Reports' },
      ]}
      backTo="/dashboard"
    >
      <div className="hr-dashboard-grid">
        {reports.map((report) => (
          <Link key={report.title} to={report.to} className="hr-dashboard-card">
            <h3>{report.title}</h3>
            <p>{report.description}</p>
          </Link>
        ))}
      </div>
    </PageShell>
  );
}

export default ReportsHub;
